import { useApiQuery } from "app/modules/api-client";
import type { AdIntelligenceController } from "app/pages/digital-marketing/ad-intelligence/common/shared/types/types";
import { chosenSites } from "app/common/services/chosenSites";
import { useDisplayAdvertiserPublisherDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDisplayAdvertiserPublisherDataAndParams";
import DurationService, { BasicDurations } from "app/services/DurationService";

export const useAdSnapshot = (controller: AdIntelligenceController, creativeUuid: string) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const primarySite = chosenSites.getPrimarySite();
    const selectedSite = params.adsSelectedSite ?? primarySite?.name;
    const { from, to, isWindow } = DurationService.getDurationData(params.duration).forAPI;

    const { data, isLoading, isError } = useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adIntelligencePublisherAdsGalleryUnifiedAdvertisersList",
            options: {
                enabled: controller === "publisher" && !!creativeUuid && Boolean(selectedSite),
                select: (response): string | undefined => {
                    return response?.data?.imageUrl;
                },
            },
        },
        {
            creativeUuid,
            key: [selectedSite],
            country: params.country,
            from,
            to,
            isWindow,
            ...(isWindow ? { latest: BasicDurations.LAST_TWENTY_EIGHT_DAYS } : {}),
        },
    );

    return {
        url: data,
        isLoading,
        isError,
    };
};
